import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import { WiMuleSQL } from "../../services/WiMuleSQL";

export const fetchLunchSnapshotById = async (id) => {
  const response = await axios.get(
    `${WiMuleSQL}/api/LunchMenu/GetLunchMealSnapshot?id=${id}`
  );

  return response.data.data;
};

export const useGetLunchSnapshotById = (id, enabled = true) =>
  useQuery({
    queryKey: ["LunchSnapshotById", id],
    queryFn: () => fetchLunchSnapshotById(id),
    enabled: enabled && !!id,
  });
